"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const CompanyImage = ({ name, imageUrl }) => {
    const [companyImageDimensions, setCompanyImageDimensions] = react_1.default.useState(null);
    function onLoadCompanyImage({ target: img }) {
        setCompanyImageDimensions({
            width: img.clientWidth,
            height: img.clientHeight,
        });
    }
    function getCompanyImageClasses() {
        let classes = { 'company-image': true };
        if (companyImageDimensions) {
            const imageRatio = companyImageDimensions.width / companyImageDimensions.height;
            const modifierClasses = {
                'company-image--square': imageRatio === 1,
                'company-image--landscape': imageRatio > 1,
                'company-image--portrait': imageRatio < 1,
            };
            classes = { ...classes, ...modifierClasses };
        }
        return (0, classnames_1.default)(classes);
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: getCompanyImageClasses(), children: (0, jsx_runtime_1.jsx)("img", { className: "company-image__img", onLoad: onLoadCompanyImage, src: imageUrl, alt: name }) }));
};
exports.CompanyImage = CompanyImage;
